import { useState, useEffect } from 'react'
import styles from './styles.module.sass'

function obtenerDecena(numero) {
    const decena = Math.ceil(numero / 10) * 10;
    const arreglo = new Array(10).fill(0).map((_, index) => decena - 9 + index);
    return arreglo;
}


const PaginationList = ({...props}) => {
    const {
        setPage,
        selectedPage = 1,
        cantResults,
        cantResultPerPage
    } = props

    const [rangePage, setRangePage] = useState([1])
    const [lastPage, setLastPage] = useState(cantResults)
    const [totalResults, setTotalResults] = useState(Number(cantResults))


    const selectPage = (index) => {
        // console.log('selectPage  ->  setPage: ',index,'  selectedPage:  ',selectedPage,' lastPage:  ',lastPage)
        setPage(index)
    }

    const more = () => {
        // console.log('more  ->  selectedPage:  ',selectedPage,' lastPage:  ',lastPage)
        if(selectedPage < lastPage){
            setPage(selectedPage + 1)
        }
    }

    const min = () => {
        // console.log('min  ->  selectedPage:  ',selectedPage)
        if(selectedPage > 1){
            setPage(selectedPage - 1)
        }
    }


    useEffect(()=>{
        // console.log('cantResults: ',cantResults)
        if( Number.isNaN( Number(cantResults)) ){
            setTotalResults(0)
        }
        else if(cantResults){
            setTotalResults(Number(cantResults))
        }
        if(cantResults){
            const ultimaPagina = Math.ceil(cantResults / cantResultPerPage)
            setLastPage(ultimaPagina)
        }
    },[cantResults])

    useEffect(()=>{
        if(selectedPage){
            const ultimaPagina = lastPage
            const rangoDePaginas = obtenerDecena(selectedPage)
            const validate = rangoDePaginas.filter(num => num === ultimaPagina)
            if(validate?.length === 1 ){
                const indiceEliminar = rangoDePaginas.indexOf(ultimaPagina)
                rangoDePaginas.splice(indiceEliminar + 1)
                setRangePage(rangoDePaginas)
            }else{
                setRangePage(rangoDePaginas)
            }
        }
    },[selectedPage, lastPage])


    return(
        totalResults >= 1
            ?
                <div className={styles?.contPagination}>
                    
                    {selectedPage !== 1
                        ?
                            <p 
                                className={styles?.prev} 
                                onClick={min} 
                                aria-hidden="true"
                            >Anterior</p>
                        : null
                    }

                    <div className={styles?.containerPages}>
                        {rangePage &&
                            rangePage.map(page => 
                                <p 
                                    key={page} 
                                    className={page === selectedPage ? `${styles?.page} ${styles?.active}` : styles?.page }
                                    onClick={() => selectPage(page)}
                                    aria-hidden="true"
                                >{page}</p>
                            )
                        }
                    </div>

                    {selectedPage !==  lastPage
                        ?
                            <p
                                className={styles?.next} 
                                onClick={more} 
                                aria-hidden="true"
                            >Siguiente</p>
                        : null
                    }

                </div>
            : null
        
    )
}

export default PaginationList